<template>
  <v-dialog :max-width="width" :max-height="height" v-model="inputVal">
    <v-card>
      <v-card-title>
        <div class="card-title">
          <h1>{{ title }}</h1>
          <span class="icon-close close" @click="inputVal = false"></span>
        </div>
      </v-card-title>
      <v-card-text class="p-0 m-0">
        <slot></slot>
      </v-card-text>
      <v-card-actions style="text-align: center">
        <v-row justify="center">
          <slot name="actions"></slot>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 900
    },
    height: {
      type: [Number, String],
      default: "auto"
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Boolean
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style>
.v-dialog::-webkit-scrollbar {
  scrollbar-width: thin;
  width: 5px;
  background-color: #f5f5f5 !important;
}

.v-dialog::-webkit-scrollbar-thumb {
  border-radius: 20px;
  display: block;
  background-color: #0875ba !important;
}

.v-dialog {
  scrollbar-width: thin !important;
  scrollbar-color: #0875ba white !important;
}

.v-card {
  border-radius: 5px !important;
}

.card-title {
  width: 100%;
  border-bottom: 1px solid black;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title .close:hover {
  opacity: 0.3;
  cursor: pointer;
}

.card-title h1 {
  font-size: large;
  font-weight: 500;
}
</style>
